import { AdvanceTable } from '@aibees/shared/features';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(AdvanceTable)`
  gap: ${(p) => p.theme.spacing(1)};

  thead {
    background-color: ${(p) => p.theme.palette.grey[100]};
    height: ${(p) => p.theme.spacing(4)};
    tr {
      th {
        padding: 0;
        padding-left: ${(p) => p.theme.spacing(2)};
      }
      th:first-of-type {
        padding: 0;
      }
    }
  }
  th {
    padding-top: 0.27rem;
    padding-bottom: 0.27rem;
  }

  tbody {
    td {
      padding: ${(p) => p.theme.spacing(0, 1.5)};
      padding-bottom: ${(p) => p.theme.spacing(0)};
      height: ${(p) => p.theme.spacing(7)};
      &:hover {
        background: ${(p) => p.theme.palette.grey[200]};
        .QuickView,
        .last-records-update {
          display: flex;
        }
        a {
          .MuiTypography-root {
            max-width: ${(p) => p.theme.spacing(19)};
          }
        }
      }
    }
    tr {
      &:hover {
        background: ${(p) => p.theme.palette.grey[100]};
        td {
          background: ${(p) => p.theme.palette.grey[200]};
        }
      }
    }
  }

  &.isChartView {
    &.AdvanceTable {
      display: none;
    }
  }

  .simplebar-horizontal {
    bottom: 0 !important;
  }
`;
